import { render } from "./CardTabs.vue?vue&type=template&id=beefa3f2"
import script from "./CardTabs.vue?vue&type=script&lang=ts"
export * from "./CardTabs.vue?vue&type=script&lang=ts"
script.render = render

export default script